import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TranslationShellComponent } from './containers/translation-shell/translation-shell.component';

const routes: Routes = [
  {
    path: '',
    component: TranslationShellComponent,
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TranslationManagementRouterModule {}
